import { AUTH_MOCK, GOOGLE_USERINFO_URL } from './config';
import { decodeMockAccessToken } from '../lib/mockAuth';

import type { GoogleUserInfo } from './types';

/**
 * Quem é o dono deste access token.
 *
 * Único ponto do fluxo que sabe da existência do mock: em desenvolvimento o
 * perfil vem de dentro do próprio token falso, e em qualquer outro ambiente a
 * pergunta é feita ao Google, como sempre. Um token que não seja do mock cai na
 * chamada real mesmo com o mock ligado — o que também é o caminho de quem
 * desliga o mock (`VITE_AUTH_MOCK=false`) para testar o Google de verdade
 * localmente.
 */
export async function fetchUserInfo(accessToken: string): Promise<GoogleUserInfo> {
  if (AUTH_MOCK) {
    const profile = decodeMockAccessToken(accessToken);
    if (profile) return profile;
  }

  const response = await fetch(GOOGLE_USERINFO_URL, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });

  if (!response.ok) {
    throw new Error(`userinfo respondeu ${response.status}`);
  }

  return (await response.json()) as GoogleUserInfo;
}
